import * as reportTableActions from './reducer';
import reportsReducer from './reducer';

export { reportTableActions };

export default reportsReducer;
